document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lumira-cc').forEach(function (section) {
    var track = section.querySelector('.lumira-cc__track');
    var prevBtn = section.querySelector('.lumira-cc__arrow--prev');
    var nextBtn = section.querySelector('.lumira-cc__arrow--next');

    if (!track) return;

    function scrollAmount() {
      var item = track.querySelector('.lumira-cc__item');
      if (!item) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return item.offsetWidth * 3 + gap * 3;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
});
